import React, { useEffect, useState } from "react";
import { Form, Typography, Alert } from "antd";
import CustomButton from "../../components/CustomButton/Button";
import CustomInput from "../../components/CustomInput/Input";
import { emailRules, phoneNumberRules } from "../../helpers/helpers";
import { useSelector, useDispatch } from "react-redux";
import { clearEditSendOtpError, editSendOtp } from "../../redux/slices/BusinessProfileSlice";
import "./NewEmailPhoneContent.scss";
import CountryCode from "../CountryCodeSelect/CountryCode";

const isEditSendOtpSuccess = (action) => {
    if (editSendOtp.rejected.match(action)) return false;
    if (editSendOtp.fulfilled.match(action)) {
        return action.payload?.statusCode === 201;
    }
    return false;
};

const { Title, Text } = Typography;

const NewEmailPhoneContent = ({
    onClose,
    setNewDetailOtpModalOpen,
    setNewDetail,
    isMobileOtp
}) => {
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const { editSendOtpError, validateOtpLoading } = useSelector((state) => state.profile1);
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    useEffect(() => {
        form.resetFields();
        dispatch(clearEditSendOtpError());
    }, [dispatch, form]);

    const onFinish = async (values) => {

        const payload = {
            email: values?.email,
        }

        if (isMobileOtp) {
            delete payload.email
            payload.mobile = values?.phone
        }

        const res = await dispatch(editSendOtp(payload));

        if (isEditSendOtpSuccess(res)) {
            setNewDetail(isMobileOtp ? values.phone : values.email);
            onClose();
            setNewDetailOtpModalOpen(true);
            form.resetFields();
        }


    };

    const handleFieldsChange = (_, allFields) => {
        const isFormValid = allFields.every(
            (field) => field.errors.length === 0 && field.value
        );
        setIsButtonDisabled(!isFormValid);
    };

    return (
        <div className="new-email-phone-content-container">
            <Title level={3}>Enter New {isMobileOtp ? "Phone number" : "Email ID"}</Title>
            <Text>Please enter the new {isMobileOtp ? "Phone number" : "Email ID"} you would like to update to.</Text>
            {!isMobileOtp && (
                <Alert
                    style={{ marginTop: 12, marginBottom: 4, textAlign: "left" }}
                    type="info"
                    showIcon
                    message="After updating your email, you will be signed out and must sign in again with the new email address."
                />
            )}
            <Form
                layout="vertical"
                className="email-phone-form"
                onFinish={onFinish}
                form={form}
                onFieldsChange={handleFieldsChange}
                initialValues={{ remember: true, countryCode: "+91" }}
            >
                {isMobileOtp ? (
                    <CustomInput
                        name="phone"
                        type="number"
                        placeholder="Enter Phone Number"
                        addonBefore={<CountryCode />}
                        rules={phoneNumberRules('')}
                    />
                ) : (
                    <CustomInput
                        name="email"
                        type="email"
                        placeholder="Enter Email ID"
                        rules={emailRules('')}
                    />
                )}

                {editSendOtpError && (
                    <Alert style={{ marginTop: 20 }} message={editSendOtpError} type="error" showIcon />
                )}

                <Form.Item>
                    <CustomButton
                        type="primary"
                        htmlType="submit"
                        block
                        className="otp-submit-btn"
                        loading={validateOtpLoading}
                        disabled={isButtonDisabled}
                    >
                        Send OTP
                    </CustomButton>
                </Form.Item>
            </Form>
        </div>
    );
};

export default NewEmailPhoneContent;
